import * as Select from '@studio/design-system/select';
import { getInfo } from '@studio/models/gamepad';
import { useLatestFn, useShallowMemo } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Props } from './types.js';

/** Gamepad `<Selector>` component. */
export const Selector = ({ available, selection, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    if (nextValue !== selection.value) {
      selection(nextValue);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={selection.value}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {useShallowMemo(
          () =>
            available
              .map(getInfo)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((info) => (
                <Select.Item key={info.gamepadId} value={info.gamepadId}>
                  <Select.ItemText>{info.name}</Select.ItemText>
                </Select.Item>
              )),
          [available]
        )}
      </Select.Content>
    </Select.Root>
  );
};
